import { type ApiClientResponse, type PaginationData, nodeApiClient, nodeApiRoutes } from 'common/services';
import type { NodeUserDataObject } from 'models/service';

export const getUserIdFromLegacyId = async (userLegacyId: string) =>
  nodeApiClient.get<PaginationData<NodeUserDataObject>, ApiClientResponse<PaginationData<NodeUserDataObject>>>(
    nodeApiRoutes.members.getById(userLegacyId),
  );
